import { useDebugValue, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import ajaxClient from '../../../../utils/ajaxClient';
import { STATE__AUTHORIZED } from '../../../../constants';

const useGetQuestionnaireCountHook = () => {
  useDebugValue('useGetQuestionnaireCountHook');

  const state = useSelector((store) => store.application.get('state'));
  const isAuthorized = useMemo(() => state === STATE__AUTHORIZED, [state]);

  const [assignedQuestionnaireCount, setAssignedQuestionnaireCount] = useState(null);
  const [assignedQuestionnaireCountFetching, setAssignedQuestionnaireCountFetching] = useState(false);
  const [returnedQuestionnaireCount, setReturnedQuestionnaireCount] = useState(null);
  const [returnedQuestionnaireCountFetching, setReturnedQuestionnaireCountFetching] = useState(false);
  const [sentQuestionnaireCount, setSentQuestionnaireCount] = useState(null);
  const [sentQuestionnaireCountFetching, setSentQuestionnaireCountFetching] = useState(false);
  const [draftQuestionnaireCount, setDraftQuestionnaireCount] = useState(null);
  const [draftQuestionnaireCountFetching, setDraftQuestionnaireCountFetching] = useState(false);
  const [approvedQuestionnaireCount, setApprovedQuestionnaireCount] = useState(null);
  const [approvedQuestionnaireCountFetching, setApprovedQuestionnaireCountFetching] = useState(false);

  const requestCount = (url, assignAction, setIsFetchingAction) => {
    ajaxClient
      .getRequest(url, null)
      .then((response) => {
        if (response) {
          if (response.data?.toString()) {
            assignAction(response.data);
          }
        }
        setIsFetchingAction(false);
      }).catch(() => {
        assignAction(null);
        setIsFetchingAction(false);
      });
  };

  const triggerAssignedQuestionnaireCount = () => {
    const url = 'Forms/Assigned/TotalCount';

    requestCount(url, setAssignedQuestionnaireCount, setAssignedQuestionnaireCountFetching);
  };

  const triggerReturnedQuestionnaireCount = () => {
    const url = 'Forms/Returned/TotalCount';

    requestCount(url, setReturnedQuestionnaireCount, setReturnedQuestionnaireCountFetching);
  };

  const triggerSentQuestionnaireCount = () => {
    const url = 'Forms/Sent/TotalCount';

    requestCount(url, setSentQuestionnaireCount, setSentQuestionnaireCountFetching);
  };

  const triggerDraftQuestionnaireCount = () => {
    const url = 'Forms/Draft/TotalCount';

    requestCount(url, setDraftQuestionnaireCount, setDraftQuestionnaireCountFetching);
  };

  const triggerApprovedQuestionaireCount = () => {
    const url = 'Forms/Approved/TotalCount';

    requestCount(url, setApprovedQuestionnaireCount, setApprovedQuestionnaireCountFetching);
  };

  const triggerQuestionnaireCount = () => {
    if (!isAuthorized) {
      return;
    }

    setAssignedQuestionnaireCountFetching(true);
    setReturnedQuestionnaireCountFetching(true);
    setSentQuestionnaireCountFetching(true);
    setDraftQuestionnaireCountFetching(true);
    setApprovedQuestionnaireCountFetching(true);

    triggerAssignedQuestionnaireCount();
    triggerReturnedQuestionnaireCount();
    triggerSentQuestionnaireCount();
    triggerDraftQuestionnaireCount();
    triggerApprovedQuestionaireCount();
  };

  return {
    assignedQuestionnaireCount,
    returnedQuestionnaireCount,
    sentQuestionnaireCount,
    draftQuestionnaireCount,
    approvedQuestionnaireCount,
    triggerQuestionnaireCount,
    countersFetching: assignedQuestionnaireCountFetching || returnedQuestionnaireCountFetching || sentQuestionnaireCountFetching || draftQuestionnaireCountFetching || approvedQuestionnaireCountFetching,
  };
};

export default useGetQuestionnaireCountHook;
